import { useEffect } from "@wordpress/element";
import Design from "./Design";
import { useWPOptionQuery } from "../../../../utils/hooks";
import { withDispatch, withSelect } from "@wordpress/data";
import { compose } from "@wordpress/compose";

const APP = ({ setPopup }) => {
  const { data, isLoading } = useWPOptionQuery("vstr_popup_design", { type: "object" });

  useEffect(() => {
    if (data) {
      setPopup({ ...data });
    }
  }, [isLoading]);

  useEffect(() => {
    localStorage.setItem("vstr_preview", true);
  }, []);

  return (
    <>
      <Design isLoading={isLoading} />
    </>
  );
};

export default compose([
  withSelect((select) => {
    const { getPopup } = select("visitor-feedback");
    return {
      popup: getPopup(),
    };
  }),
  withDispatch((dispatch) => {
    const { setPopup } = dispatch("visitor-feedback");
    return {
      setPopup,
    };
  }),
])(APP);
